import { axiosRequest } from '@/util/axios-request';
var method = 'get';
var listUrl = '/web/msg/list';
var addUrl = '/web/msg/add';
var detailUrl = '/web/msg/detail';
var cancelUrl = '/web/msg/cancel';
var topUrl = '/web/msg/top';
var exportUrl = '/web/msg/export';

// 消息列表
export var listFn = function listFn(params) {
  return axiosRequest({
    url: listUrl,
    method: method,
    params: params
  });
};

// 消息添加
export var addFn = function addFn(data) {
  return axiosRequest({
    url: addUrl,
    data: data
  });
};

// 消息详情
export var detailFn = function detailFn(params) {
  return axiosRequest({
    url: detailUrl,
    method: method,
    params: params
  });
};

// 消息撤回
export var cancelFn = function cancelFn(data) {
  return axiosRequest({
    url: cancelUrl,
    data: data
  });
};

// 消息置顶
export var topFn = function topFn(data) {
  return axiosRequest({
    url: topUrl,
    data: data
  });
};

// 消息列表
export var exportFn = function exportFn(params) {
  return axiosRequest({
    url: exportUrl,
    method: method,
    params: params
  });
};

// 签字消息导出列表查询
export var exportPdfList = function exportPdfList(params) {
  return axiosRequest({
    url: '/web/msg/exportPdfList',
    method: method,
    params: params
  });
};

// 签字消息PDF导出
export var exportPdf = function exportPdf(params) {
  return axiosRequest({
    url: '/web/msg/exportPdf',
    method: method,
    params: params
  });
};